import { IDriverState } from "./types";


export const initialDriverState: IDriverState = {
	bookingDrivers: []
};